{
  "version": 1,
  "asset_id": "412f6961-0692-48f6-9531-c37ccedf111c",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/412f6961-0692-48f6-9531-c37ccedf111c/hero-notice.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/412f6961-0692-48f6-9531-c37ccedf111c/hero-notice.jpg",
  "original_filename": "hero-notice.jpg",
  "size": 137466,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:07Z"
}
